import {
  buildingPermitStatus,
  permitsDevelopmentStatus,
} from "configs/proposedProject.config";
import { DatePicker, Dropdown, FilePicker, Input, Textarea } from "stories";
import { ConditionalFormRenderer } from "../../../../../../../stories/components/FormRenderer/ConditionalFormRenderer";

export const getPermitBuildPermitDefaultValue = () => ({
  date: null,
  description: "",
  filename: "",
  reading_stage: "",
  status: "",
});

export const getPermitDefaultValue = () => ({
  development_permit: {
    build_permit: getPermitBuildPermitDefaultValue(),
    date: null,
    description: "",
    filename: "",
    reading_stage: "",
    status: "",
  },
});

export const permitFormFields = [
  [
    {
      renderAsFormItem: false,
      component: ConditionalFormRenderer,
      props: {
        cacheable: true,
        getDefaultValues: getPermitDefaultValue,
        conditionFieldName: "development_permit.status",
        fallBackFields: [
          [
            {
              name: "development_permit.status",
              component: Dropdown,
              props: {
                list: permitsDevelopmentStatus,
                label: "Development Permit Status",
                defaultValue: "",
              },
            },
            {},
          ],
        ],
        conditionalFields: {
          "obtained/approved": [
            [
              {
                name: "development_permit.status",
                component: Dropdown,
                props: {
                  list: permitsDevelopmentStatus,
                  label: "Development Permit Status",
                  defaultValue: "",
                },
              },
              {},
            ],
            [
              {
                name: "development_permit.description",
                component: Textarea,
                props: {
                  label: "Permit Description",
                },
              },
              {},
            ],
            [
              {
                name: "development_permit.date",
                component: DatePicker,
                props: {
                  label: "Issuance Date",
                },
              },
              {},
            ],
            [
              {
                name: "development_permit.filename",
                component: FilePicker,
                props: {
                  label: "Approved Development Permit",
                  type: "file",
                },
              },
              {},
            ],
            [
              {
                renderAsFormItem: false,
                component: ConditionalFormRenderer,
                props: {
                  cacheable: true,
                  getDefaultValues: () => ({
                    "development_permit.build_permit.date": null,
                    "development_permit.build_permit.description": "",
                    "development_permit.build_permit.filename": "",
                    "development_permit.build_permit.reading_stage": "",
                    "development_permit.build_permit.status": "",
                  }),
                  conditionFieldName: "development_permit.build_permit.status",
                  fallBackFields: [
                    [
                      {
                        name: "development_permit.build_permit.status",
                        component: Dropdown,
                        props: {
                          list: buildingPermitStatus,
                          label: "Building Permit Status",
                          defaultValue: "",
                        },
                      },
                      {},
                    ],
                  ],
                  conditionalFields: {
                    "obtained/approved": [
                      [
                        {
                          name: "development_permit.build_permit.status",
                          component: Dropdown,
                          props: {
                            list: buildingPermitStatus,
                            label: "Building Permit Status",
                            defaultValue: "",
                          },
                        },
                        {},
                      ],
                      [
                        {
                          name: "development_permit.build_permit.description",
                          component: Textarea,
                          props: {
                            label: "Permit Description",
                          },
                        },
                        {},
                      ],
                      [
                        {
                          name: "development_permit.build_permit.date",
                          component: DatePicker,
                          props: {
                            label: "Issuance Date",
                          },
                        },
                        {},
                      ],
                      [
                        {
                          name: "development_permit.build_permit.filename",
                          component: FilePicker,
                          props: {
                            label: "Approved Building Permit",
                            type: "file",
                          },
                        },
                        {},
                      ],
                    ],
                    submitted: [
                      [
                        {
                          name: "development_permit.build_permit.status",
                          component: Dropdown,
                          props: {
                            list: buildingPermitStatus,
                            label: "Building Permit Status",
                            defaultValue: "",
                          },
                        },
                        {
                          name: "development_permit.build_permit.reading_stage",
                          component: Input,
                          props: {
                            label: "Current Reading Stage",
                          },
                        },
                      ],
                      [
                        {
                          name: "development_permit.build_permit.description",
                          component: Textarea,
                          props: {
                            label: "Permit Description",
                          },
                        },
                        {},
                      ],
                      [
                        {
                          name: "development_permit.build_permit.date",
                          component: DatePicker,
                          props: {
                            label: "Expected Date of Obtaining/Approval",
                          },
                        },
                        {},
                      ],
                      [
                        {
                          name: "development_permit.build_permit.filename",
                          component: FilePicker,
                          props: {
                            label: "Submitted Building Permit",
                            type: "file",
                          },
                        },
                        {},
                      ],
                    ],
                    "not-submitted": [
                      [
                        {
                          name: "development_permit.build_permit.status",
                          component: Dropdown,
                          props: {
                            list: buildingPermitStatus,
                            label: "Building Permit Status",
                            defaultValue: "",
                          },
                        },
                        {
                          name: "development_permit.build_permit.date",
                          component: DatePicker,
                          props: {
                            label: "Expected Submission Date",
                          },
                        },
                      ],
                    ],
                  },
                },
              },
            ],
          ],
          submitted: [
            [
              {
                name: "development_permit.status",
                component: Dropdown,
                props: {
                  list: permitsDevelopmentStatus,
                  label: "Development Permit Status",
                  defaultValue: "",
                },
              },
              {
                name: "development_permit.reading_stage",
                component: Input,
                props: {
                  label: "Current Reading Stage",
                },
              },
            ],
            [
              {
                name: "development_permit.description",
                component: Textarea,
                props: {
                  label: "Permit Description",
                },
              },
              {},
            ],
            [
              {
                name: "development_permit.date",
                component: DatePicker,
                props: {
                  label: "Expected Date of Obtaining/Approval",
                },
              },
              {},
            ],
            [
              {
                name: "development_permit.filename",
                component: FilePicker,
                props: {
                  label: "Submitted Development Permit",
                  type: "file",
                },
              },
              {},
            ],
          ],
          "not-submitted": [
            [
              {
                name: "development_permit.status",
                component: Dropdown,
                props: {
                  list: permitsDevelopmentStatus,
                  label: "Development Permit Status",
                  defaultValue: "",
                },
              },
              {
                name: "development_permit.date",
                component: DatePicker,
                props: {
                  label: "Expected Submission Date",
                },
              },
            ],
          ],
        },
      },
    },
  ],
];
